import React from 'react'
import PropTypes from 'prop-types'
import {icon} from '@salesforce/retail-react-app/app/components/icons'
import '../../../../assets/svg/brand-logo-default.svg'
import '../../../../assets/svg/brand-logo-inverted.svg'
import NutribulletBlueIcon from '../brand/NutribulletBlueIcon'
import {BRAND_KEY} from '../../../../brand'

export const vbrandViewBoxes = {
    delonghi: '0 0 169 55',
    nutribullet: '0 0 120 34',
    kenwood: '0 0 180 27',
}

const BrandLogoDefault = icon('brand-logo-default', {viewBox: vbrandViewBoxes[BRAND_KEY]})
const BrandLogoInverted = icon('brand-logo-inverted', {viewBox: vbrandViewBoxes[BRAND_KEY]})

const BrandLogo = (props) => {
    let Icon = null
    Icon = BrandLogoDefault
    if (props.inverted) {
        Icon = BrandLogoInverted
    }
    if (props.nutribulletBlueBrandLogo) {
        Icon = NutribulletBlueIcon
    }

    return <Icon {...props} inverted={props.inverted ? 'true' : undefined} />
}

BrandLogo.propTypes = {
    onClick: PropTypes.func,
    inverted: PropTypes.bool,
    nutribulletBlueBrandLogo: PropTypes.bool,
}

export default BrandLogo
